module.exports = __webpack_public_path__ + "static/media/triplecherry.8e104d5f.jpeg";